module.exports = __webpack_public_path__ + "static/media/IconPasswordOff.51e9f6ca.svg";